<template>
  <dropdown
    :align="align"
    :active="menuOpen"
    @close="menuOpen = false"
  >
    <btn
      icon="arrow_drop_down"
      v-bind="$attrs"
      @click="menuOpen = !menuOpen"
    >
      {{ label }}
    </btn>

    <template #menu>
      <dropdown-menu
        :options="options"
        @select="handleSelect"
      />
    </template>
  </dropdown>
</template>

<script>
import Dropdown from './Dropdown';
import DropdownMenu from './DropdownMenu';
import Btn from './Btn';

export default {
  components: {
    Dropdown,
    DropdownMenu,
    Btn,
  },

  props: {
    options: Array,
    label: String,
    align: {
      type: String,
      default: 'right',
    },
  },

  data() {
    return {
      menuOpen: false,
    };
  },

  methods: {
    handleSelect(value) {
      this.menuOpen = false;
      this.$emit('click', value);
    },
  },
};
</script>
